import React from 'react';
import Box from '@mui/material/Box';
import { useAppSelector, useAppDispatch } from '../../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Redux 

import { setOpenPopup, setPopupAction } from '../../../../../../../redux/features/general/popup';

// Components 

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelButton from '../../../../../../general/inputs/CancelButton';

const CategoryTitle: React.FC = () => {

    const { t } = useTranslation();

    const dispatch = useAppDispatch(); 

    const colors = useAppSelector(state => state.theme.colors);
    const section = useAppSelector((state) => state.createPatient.section); 

    // -- 

    const handleOpenPopup = () => { 

        dispatch(setOpenPopup()); 
        dispatch(setPopupAction('cancelPatientCreation')); 

    }; 

    // --

    return (

        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between', 
            marginTop: '1vh',
            fontWeight: 'bold',
            marginBottom: 5,
            width: '100%',
            height: 'width',
            color: colors?.text, 
        }}>
            <Box>{t(section)}</Box>

            <CancelButton handler={handleOpenPopup} extraStyle={{ fontSize: 30 }} />

        </Box>
  );
};

export default CategoryTitle;